module.exports = __webpack_public_path__ + "img/icon-truck.bccc9751.svg";